module.exports = __webpack_public_path__ + "static/img/Banner_600x300_y.ab7e553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/Banner_600x300_y.jpg
// module id = rN1b
// module chunks = 0